import { render, staticRenderFns } from "./common-sucessdemo.vue?vue&type=template&id=2cbf5f56&scoped=true"
import script from "./common-sucessdemo.vue?vue&type=script&lang=js"
export * from "./common-sucessdemo.vue?vue&type=script&lang=js"
import style0 from "./common-sucessdemo.vue?vue&type=style&index=0&id=2cbf5f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbf5f56",
  null
  
)

export default component.exports